module.exports={data:[{text:"Cunning"},{text:"Discipline"},{text:"Rule"},{text:"Strength"},{text:"Swordplay"},{text:"Valor"},{text:"Warfare"}]};